<template>
    <el-dialog
        :title="title"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form ref="form" :model="form"  :rules="rules">
            <el-form-item label="所属学校" prop="schoolName" label-width="100px">
            <el-select v-model="form.schoolName" filterable placeholder="请选择学校" @change="schoolClick">
                 <el-option :label="item.name" :value="item.id" v-for="item in schoolList" :key="item.value"  ></el-option>
            </el-select>
        </el-form-item>
            <el-form-item label="名称" prop="name" label-width="100px">
                <el-input  v-model="form.name"  autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="类型" label-width="100px">
            <el-select v-model="pointType" filterable placeholder="请选择学校" @change="schoolClick">
                <el-option :label="item.label" :value="item.value" v-for="item in typeData" :key="item.value"  ></el-option>
             </el-select>
        </el-form-item>
<!--            <el-form-item label="控制门禁" prop="radio" label-width="100px" >
                <el-radio-group  v-model="form.radio" >
                    <el-radio  label="否"></el-radio>
                    <el-radio  label="是"></el-radio>
                </el-radio-group>
            </el-form-item> -->
            <div class="buttom-box">
                    <el-button type="primary" @click="onSubmit('form')">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { readerCardPointAddOrUpdate ,readerCardPointbaseInfoe} from '@/assets/api/schoollog'
import { ElMessage } from 'element-plus'
import {school} from '@/assets/api/renyuan'


export default {
    components: {
    },
     props: ['xiugaiObj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            form:{
                schoolName:'',
                name:'',
                radio:"否"
            },
            schoolList:'',
            typeData:[
                {
                    value:'dormitory',
                    label:'宿舍'
                },
                {
                    value:'school',
                    label:'学校'
                },
            ],
            pointType:'school',
            rules: {
                name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                      ],
                schoolName: [
                        { required: true, message: '请输入学校', trigger: 'blur' },
                      ],
                radio: [
                        { required: true, message: '请选择是否门禁', trigger: 'blur' },
                      ],
                pointType: [
                        { required: true, message: '请选择类型', trigger: 'blur' },
                      ],
            }
        }

    },
    created(){
    },
    mounted(){
        this.schoolPost()
        if (JSON.stringify(this.xiugaiObj) !== "{}") {
            console.log(this.xiugaiObj,'修改imei');
            this.title = '修改读卡点管理'
            const params = {
                id:this.xiugaiObj.readPointId
            }
            readerCardPointbaseInfoe(params).then((res) => {
                console.log(res,'成功');
                this.form.name = res.data.data.name
                this.form.schoolName = res.data.data.schoolName
                this.pointType= res.data.data.pointType
                this.form.radio = res.data.data.checked == 1 ? '是':'否'
            }).catch((err) => {
                console.log(err,'失败');
            })

        }else{
            console.log(this.xiugaiObj,'新增imei');
            this.title = '新增读卡点管理'

        }
        
    },
    methods:{
        handleClose() {
            this.$emit('AddShowClick')
      },
      schoolPost (schooName) {
            let params = {
                page: '1',
                pageSize: '999',
                schoolName: schooName || '',
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            school(params).then((res)=> {
                // console.log(res,'学校列表');
                this.schoolList = res.data.data.list
            }).catch((err)=> {
                console.log(err);
            })
        },
      //新增
      readerCardPointAdd(){
        const params = {
            //checked:this.form.radio =='否'?'0':'1',
			checked:"0",
            schoolId:this.form.schoolName,
            name:this.form.name,
            pointType:this.pointType,
        }
        readerCardPointAddOrUpdate(params).then((res) => {
            ElMessage.success('添加成功')
            this.handleClose()

        }).catch((err)=> {
            ElMessage.error("添加失败");

        })
      },
      //修改
      readerCardPointXiu(){
        const params = {
            //checked:this.form.radio =='否'?'0':'1',
			checked:"0",
            id:this.xiugaiObj.readPointId,
            name:this.form.name,
            schoolName:this.form.schoolName,
            pointType:this.pointType,

            // duration:new Date(),
        }
        readerCardPointAddOrUpdate(params).then((res) => {
            console.log(res,'2');

            ElMessage.success('修改成功')
            this.handleClose()

        }).catch((err)=> {
            console.log(err,'1');
            ElMessage.error("删除失败");

        })
      },
      onSubmit(formName) {
        console.log(formName);
              this.$refs[formName].validate((valid) => {
              if (valid) {
                if( this.title == '修改读卡点管理') {
                    this.readerCardPointXiu()

                    } else if( this.title == '新增读卡点管理'){
                        this.readerCardPointAdd()
                    }
              } else {
                  return false;

              }
              });
          },

    }
    }




</script>
<style  scoped lang="scss">
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 400px;
    }
    .el-form-item--small{
        width: 70% !important;
    }
     
    }
</style>